package com.partejar.app.core.security

import androidx.compose.runtime.Composable

@Composable
actual fun AppLifecycleObserver(onBackground: () -> Unit, onForeground: () -> Unit) = Unit
